/* see https://fkhadra.github.io/react-toastify/how-to-style */
import styled from "styled-components";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const StyledToastContainer = styled(ToastContainer)`
  ${({theme}) => `
    font-size: 14px;
    color: #1f1f1f;
    bottom: 0px;
    font-family: inherit;

    position: static;
    transform: none;
    left: auto;
    bottom: auto;

    .Toastify__toast {
            min-height: 50px;
    }
    .Toastify__toast--error {}
    .Toastify__toast--warning {}
    .Toastify__toast--success {}
    .Toastify__toast-body {}
    .Toastify__progress-bar {
       background: linear-gradient(to right, ${theme.skeleton.color}, ${theme.skeleton.highlightColor});
    }
  `}
`;

export default StyledToastContainer;
